import {history} from 'new-components/router/history';
import {takeEvery} from "@redux-saga/core/effects";
import {OPEN_EXTERNAL_LINK, OPEN_MENU_ENTRY_LINK, OPEN_RESTAURANT_LINK} from "../constants/link.constants";
import {getRestaurantRoute} from "../helpers/routes.helper";

function* openExternalLink(action) {
	window.open(action.url, '_blank');
}

function* openRestaurantLink(action) {
	window.location.href = window.location.origin + '/restaurant/' + action.restaurantId;
}

function* openMenuEntryLink(action) {
	history.replace(
		getRestaurantRoute(action.menuEntryId)
	);
}

export const linkSaga = function* linkSaga() {
	yield takeEvery([OPEN_EXTERNAL_LINK], openExternalLink);
	yield takeEvery([OPEN_RESTAURANT_LINK], openRestaurantLink);
	yield takeEvery([OPEN_MENU_ENTRY_LINK], openMenuEntryLink);
};
